<div class="epg-user-menu-content">
  <ng-content></ng-content>
</div>
